import Keycloak from 'keycloak-js';
import env from '@ludovicm67/react-dotenv';

//When you instantiate Keycloak, it will set events in the queue to refresh the token upon token expiration automatically
const keycloakInstance = new Keycloak({
    url: env?.REACT_APP_IAM_AUTH_SERVER_URL,
    realm: env?.REACT_APP_IAM_REALM as string,
    clientId: env?.REACT_APP_IAM_CLIENT_ID as string,
});
export default keycloakInstance;